export default __webpack_public_path__ + "static/media/new-header-video.422fa312.webm";